/* HYPE SIDE — coluna de compra da página de produto
   - guia de tamanhos em painel lateral
   - cartão de personalização (interruptor + pré-visualização)
   - faixa "Compra 2, leva 3" ligada ao carrinho
   - badges (pdp-badges): escolhe 1, opcional
   - total no botão "Adicionar ao carrinho" (preço + personalização + badge)
   - envio para o carrinho quando há extras: camisola + serviço de
     personalização + badge, tudo com o mesmo nº de unidades
   - cupão: botão "Copiar" (o que mostrar é decidido em pdp-coupon)
   Sem extras, a compra segue pelo product-form do tema. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    // Só a página de produto principal (a janela de escolha rápida não corre isto)
    var info = document.querySelector('product-info .product__info-container, .product__info-container');
    if (!info || info.closest('quick-add-modal')) return;

    /* ---------- dinheiro ---------- */
    function priceEl() { return info.querySelector('[data-pdp-price]'); }
    function money(cents) {
      var el = priceEl();
      var fmt = (el && el.getAttribute('data-money-format')) || '€{{amount_with_comma_separator}}';
      var n = (cents / 100).toFixed(2);
      var comma = n.replace('.', ',');
      var dot = n;
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        if (k === 'amount_no_decimals') return String(Math.round(cents / 100));
        if (k === 'amount_with_comma_separator') return comma;
        if (k === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100));
        return dot;
      });
    }

    /* ---------- galeria: traços por baixo da foto (telemóvel) ----------
       Um traço por foto; o da foto à vista fica comprido. Tocar num traço leva à foto. */
    (function () {
      var list = document.querySelector('.product__media-wrapper .product__media-list');
      if (!list) return;
      var slides = Array.prototype.filter.call(list.children, function (li) {
        return li.classList.contains('product__media-item');
      });
      if (slides.length < 2) return;
      var dots = document.createElement('div');
      dots.className = 'pdp-dots';
      dots.setAttribute('aria-label', 'Fotos');
      slides.forEach(function (slide, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Foto ' + (i + 1) + ' de ' + slides.length);
        b.addEventListener('click', function () {
          list.scrollTo({ left: slide.offsetLeft - list.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
      list.insertAdjacentElement('afterend', dots);
      function update() {
        var w = slides[0].getBoundingClientRect().width || 1;
        var i = Math.max(0, Math.min(slides.length - 1, Math.round(list.scrollLeft / w)));
        Array.prototype.forEach.call(dots.children, function (b, j) {
          b.setAttribute('aria-current', j === i ? 'true' : 'false');
        });
      }
      list.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    })();

    /* ---------- guia de tamanhos (painel lateral) ---------- */
    var drawer = document.querySelector('[data-pdp-fit-drawer]');
    var openBtn = info.querySelector('[data-pdp-fit-open]');
    if (drawer && openBtn && typeof drawer.showModal === 'function') {
      openBtn.addEventListener('click', function () { drawer.showModal(); });
      drawer.querySelector('[data-pdp-fit-close]').addEventListener('click', function () { drawer.close(); });
      drawer.addEventListener('click', function (e) { if (e.target === drawer) drawer.close(); });
    } else if (openBtn) {
      openBtn.hidden = true;
    }

    /* ---------- personalização ---------- */
    var perso = info.querySelector('[data-pdp-perso]');
    var nome = document.getElementById('pdp-perso-nome');
    var numero = document.getElementById('pdp-perso-numero');
    var persoCents = perso ? parseInt(perso.getAttribute('data-perso-cents'), 10) || 0 : 0;

    function persoFilled() {
      return !!((nome && nome.value.trim()) || (numero && numero.value.trim()));
    }
    function refreshPreview() {
      if (!perso) return;
      var pn = perso.querySelector('[data-pdp-perso-pname]');
      var pu = perso.querySelector('[data-pdp-perso-pnum]');
      if (pn) pn.textContent = (nome && nome.value.trim().toUpperCase()) || 'NOME';
      if (pu) pu.textContent = (numero && numero.value.trim()) || '10';
      perso.classList.toggle('is-filled', persoFilled());
    }
    if (perso) {
      var toggle = perso.querySelector('[data-pdp-perso-toggle]');
      var body = perso.querySelector('[data-pdp-perso-body]');
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        perso.classList.toggle('is-open', open);
        body.hidden = !open;
        if (open) {
          if (nome) nome.focus({ preventScroll: true });
          keepPersoVisible();
        } else {
          // Fechar = sem personalização (e sem cobrança)
          if (nome) nome.value = '';
          if (numero) numero.value = '';
        }
        refreshPreview();
        refreshTotal();
      });
      if (numero) {
        numero.addEventListener('input', function () {
          var clean = numero.value.replace(/\D/g, '').slice(0, 2);
          if (clean !== numero.value) numero.value = clean;
        });
      }
      [nome, numero].forEach(function (el) {
        if (!el) return;
        el.addEventListener('input', function () { refreshPreview(); refreshTotal(); });
        el.addEventListener('focus', function () {
          document.documentElement.classList.add('perso-typing');
          keepPersoVisible();
        });
        el.addEventListener('blur', function () {
          document.documentElement.classList.remove('perso-typing');
        });
      });

      // Telemóvel: o teclado tapa o cartão. Leva o cartão (pré-visualização +
      // campos) para o topo da área visível, acima do teclado.
      var isMobile = window.matchMedia('(max-width: 989px)');
      var scrollTimer;
      function scrollPersoIntoView() {
        var vv = window.visualViewport;
        var vvTop = vv ? vv.offsetTop : 0;
        // cabeçalho fixo visível no topo: o cartão fica logo abaixo dele
        var header = document.querySelector('sticky-header, .section-header');
        var headerH = header ? Math.max(0, header.getBoundingClientRect().bottom - vvTop) : 0;
        var top = perso.getBoundingClientRect().top - vvTop - headerH - 12;
        if (Math.abs(top) > 4) window.scrollBy({ top: top, behavior: 'smooth' });
      }
      function keepPersoVisible() {
        if (!isMobile.matches) return;
        clearTimeout(scrollTimer);
        // espera o teclado abrir (o iOS redimensiona o visualViewport)
        scrollTimer = setTimeout(scrollPersoIntoView, 320);
      }
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', function () {
          var a = document.activeElement;
          if (a === nome || a === numero) keepPersoVisible();
        });
      }
    }

    /* ---------- badges ---------- */
    var badgeBox = info.querySelector('[data-pdp-badges]');
    function selectedBadge() {
      return badgeBox ? badgeBox.querySelector('[data-pdp-badge][aria-pressed="true"]') : null;
    }
    // A manga mostra o badge escolhido; por baixo, o resumo do que vai na camisola
    function refreshBadgePreview() {
      if (!badgeBox) return;
      var sel = selectedBadge();
      var img = badgeBox.querySelector('[data-pdp-badges-preview]');
      var summary = badgeBox.querySelector('[data-pdp-badges-summary]');
      badgeBox.classList.toggle('has-badge', !!sel);
      if (img) {
        var src = sel && sel.getAttribute('data-img');
        if (src) {
          img.src = src;
          img.hidden = false;
          // reinicia a animação de "aplicar" na manga
          img.classList.remove('is-in');
          void img.offsetWidth;
          img.classList.add('is-in');
        } else {
          img.hidden = true;
        }
      }
      if (summary) {
        summary.innerHTML = sel
          ? 'Na manga: <b></b> · <span></span>'
          : 'Sem badge';
        if (sel) {
          summary.querySelector('b').textContent = sel.getAttribute('data-name');
          summary.querySelector('span').textContent = '+ ' + sel.getAttribute('data-price');
        }
      }
    }
    if (badgeBox) {
      badgeBox.addEventListener('click', function (e) {
        var card = e.target.closest('[data-pdp-badge]');
        if (!card) return;
        var on = card.getAttribute('aria-pressed') !== 'true';
        // Só um de cada vez; tocar outra vez tira-o
        badgeBox.querySelectorAll('[data-pdp-badge]').forEach(function (c) {
          c.setAttribute('aria-pressed', 'false');
        });
        if (on) card.setAttribute('aria-pressed', 'true');
        refreshBadgePreview();
        refreshTotal();
      });
    }

    /* ---------- botão com total ---------- */
    function qty() {
      var q = document.querySelector('input[name="quantity"][form^="product-form-"]') || info.querySelector('input[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    function ensureButton() {
      var btn = info.querySelector('.product-form__submit');
      if (!btn) return null;
      if (!btn.querySelector('[data-pdp-atc-total]')) {
        btn.classList.add('pdp-atc');
        var wrap = document.createElement('span');
        wrap.className = 'pdp-atc__total';
        wrap.setAttribute('data-pdp-atc-total', '');
        wrap.innerHTML = '<span class="pdp-atc__now"></span><s class="pdp-atc__was"></s>';
        var spinner = btn.querySelector('.loading__spinner');
        btn.insertBefore(wrap, spinner || null);
      }
      return btn;
    }
    function setText(el, text) {
      if (el && el.textContent !== text) el.textContent = text;
    }
    function refreshTotal() {
      var el = priceEl();
      var btn = ensureButton();
      if (!el || !btn) return;
      var price = parseInt(el.getAttribute('data-price'), 10) || 0;
      var compare = parseInt(el.getAttribute('data-compare'), 10) || 0;
      var extra = persoFilled() ? persoCents : 0;
      var badge = selectedBadge();
      if (badge) extra += parseInt(badge.getAttribute('data-cents'), 10) || 0;
      var n = qty();
      var total = (price + extra) * n;
      var was = compare > price ? (compare + extra) * n : 0;
      var box = btn.querySelector('[data-pdp-atc-total]');
      // Só escreve quando muda: escrever o mesmo texto também dispara os observadores
      setText(box.querySelector('.pdp-atc__now'), money(total));
      var s = box.querySelector('.pdp-atc__was');
      setText(s, was ? money(was) : '');
      if (s.hidden !== !was) s.hidden = !was;

      var stickyBtn = document.querySelector('[data-pdp-sticky-btn]');
      if (stickyBtn) {
        setText(stickyBtn, btn.disabled ? 'Esgotado' : 'Adicionar · ' + money(total));
        if (stickyBtn.disabled !== btn.disabled) stickyBtn.disabled = btn.disabled;
      }
    }

    /* ---------- faixa "Compra 2, leva 3" ---------- */
    // A cada 3 camisolas no carrinho, a mais barata sai grátis. Conta as que já
    // lá estão (sem o serviço de personalização) + esta, e diz quanto falta.
    var promo = info.querySelector('[data-pdp-promo]');
    var PERSO_HANDLE = 'personalizacao-nome-e-numero';
    function isService(it) {
      return it.handle === PERSO_HANDLE || (it.handle || '').indexOf('badge-') === 0;
    }
    function refreshPromo(inCart) {
      if (!promo) return;
      var withThis = inCart + 1;
      var step = withThis % 3;
      var lit = step === 0 ? 3 : step;
      promo.querySelectorAll('[data-pdp-promo-dot]').forEach(function (d, i) {
        d.classList.toggle('is-on', i < lit);
        d.classList.toggle('is-next', i === lit);
      });
      promo.classList.toggle('is-done', step === 0);
      // Mesmas frases que pdp-tiers
      var html;
      if (step === 0) {
        html = '<span class="is-ok">Boa! Com esta tens 3 camisolas: a mais barata fica GRÁTIS ✓</span>';
      } else if (lit === 2) {
        html = 'Com esta tens <b>2</b>. <b>Só falta mais 1</b> camisola e a mais barata fica <b class="is-free">GRÁTIS</b>.';
      } else {
        html = 'Esta é a tua <b>1.ª</b>. Junta mais <b>2</b> camisolas (de qualquer clube) e a mais barata fica <b class="is-free">GRÁTIS</b>.';
      }
      var text = promo.querySelector('[data-pdp-promo-text]');
      if (text.innerHTML !== html) text.innerHTML = html;
    }
    function loadCart() {
      if (!promo) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var n = (c.items || []).reduce(function (sum, it) {
            return isService(it) ? sum : sum + it.quantity;
          }, 0);
          refreshPromo(n);
        })
        .catch(function () {});
    }
    // O estado inicial já vem do servidor (pdp-tiers); aqui só se atualiza
    // depois de cada adição ao carrinho
    if (promo && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, loadCart);
    }

    /* ---------- reações ---------- */
    document.addEventListener('change', function (e) {
      if (e.target.closest && (e.target.closest('variant-selects') || e.target.name === 'quantity')) {
        refreshTotal();
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.quantity__button')) setTimeout(refreshTotal, 0);
    });
    // O tema volta a desenhar o preço e o botão ao trocar de tamanho
    var priceHost = info.querySelector('[id^="price-"]');
    if (priceHost) new MutationObserver(function () { refreshTotal(); }).observe(priceHost, { childList: true, subtree: true });
    // Botão trocado ou ativado/desativado pelo tema (sem subtree: o total que
    // escrevemos dentro do botão não pode voltar a disparar isto)
    var formBtns = info.querySelector('.product-form__buttons');
    if (formBtns) {
      var watchBtn = function () {
        var b = formBtns.querySelector('.product-form__submit');
        if (b) btnObserver.observe(b, { attributes: true, attributeFilter: ['disabled'] });
      };
      var btnObserver = new MutationObserver(function () { refreshTotal(); });
      new MutationObserver(function () { watchBtn(); refreshTotal(); }).observe(formBtns, { childList: true });
      watchBtn();
    }

    /* ---------- envio com extras (personalização / badge) ---------- */
    var form = info.querySelector('product-form form[id^="product-form-"]') ||
      document.querySelector('form[id^="product-form-"]:not([id*="installment"])');
    var persoVariant = perso ? perso.getAttribute('data-perso-variant') : null;

    // Atualiza a bolha do carrinho no cabeçalho sem recarregar a página
    function updateBubble() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden)').forEach(function (el) {
            el.textContent = c.item_count;
          });
          var bubble = document.querySelector('.cart-count-bubble');
          if (bubble) bubble.hidden = c.item_count === 0;
        });
    }
    // Confirmação discreta, sem tirar o cliente da página
    function showAdded() {
      var note = document.querySelector('[data-perso-adicionado]');
      if (!note) {
        note = document.createElement('div');
        note.setAttribute('data-perso-adicionado', '');
        note.className = 'perso-adicionado';
        note.innerHTML = '<span>Adicionado ao carrinho</span> <a href="/cart">Ver carrinho</a>';
        document.body.appendChild(note);
      }
      note.classList.add('is-visible');
      clearTimeout(note._t);
      note._t = setTimeout(function () { note.classList.remove('is-visible'); }, 4000);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        var withPerso = !!persoVariant && persoFilled();
        var badge = selectedBadge();
        if (!withPerso && !badge) return; // sem extras: fluxo normal do tema

        e.preventDefault();
        e.stopImmediatePropagation();

        var btn = form.querySelector('[name="add"]');
        if (btn) btn.setAttribute('aria-disabled', 'true');

        var fd = new FormData(form);
        var n = parseInt(fd.get('quantity'), 10) || qty();

        // Só as propriedades preenchidas — evita criar linhas diferentes por causa de campos vazios
        var props = {};
        var vNome = nome && nome.value.trim();
        var vNum = numero && numero.value.trim();
        if (vNome) props['Nome'] = vNome;
        if (vNum) props['Número'] = vNum;
        if (badge) {
          props['Badge'] = badge.getAttribute('data-title');
          // Liga a camisola ao produto do badge (escondido no checkout; usado por cart-perso-guard)
          props['_badge'] = badge.getAttribute('data-variant');
        }

        var items = [{ id: fd.get('id'), quantity: n, properties: props }];
        // Os serviços vão sem propriedades: cada um fica sempre numa única linha do carrinho
        if (withPerso) items.push({ id: persoVariant, quantity: n });
        if (badge) items.push({ id: badge.getAttribute('data-variant'), quantity: n });

        // O cliente fica na página: o carrinho do tema é atualizado e aberto
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var body = { items: items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
          body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (cart && typeof cart.renderContents === 'function' && !res.status) {
              // Abre o painel lateral com o conteúdo já atualizado
              if (cart.classList) cart.classList.remove('is-empty');
              cart.renderContents(res);
            } else {
              updateBubble();
              showAdded();
            }
          })
          .catch(function () {
            updateBubble();
            showAdded();
          })
          .finally(function () {
            if (btn) btn.removeAttribute('aria-disabled');
          });
      }, true);
    }

    refreshPreview();
    refreshTotal();

    /* ---------- cupão ----------
       O que mostrar já é decidido em pdp-coupon (servidor + script inline,
       para aparecer sem atraso). Aqui só o botão "Copiar". */
    var coupon = info.querySelector('[data-pdp-coupon]');
    if (!coupon) return;
    var codeBtn = coupon.querySelector('[data-pdp-coupon-code]');
    var applyBtn = coupon.querySelector('[data-pdp-coupon-apply]');
    function copy() {
      var code = codeBtn.textContent.trim();
      if (!code || !navigator.clipboard || !navigator.clipboard.writeText) return;
      navigator.clipboard.writeText(code).then(function () {
        applyBtn.textContent = 'Copiado ✓';
        codeBtn.setAttribute('data-copied', '');
        setTimeout(function () {
          applyBtn.textContent = 'Copiar';
          codeBtn.removeAttribute('data-copied');
        }, 1800);
      }, function () {});
    }
    codeBtn.addEventListener('click', copy);
    applyBtn.addEventListener('click', copy);
  });
})();
